<template>
  <div class="app-container">
    <wd-navbar class="control-header">
      <div slot="left" class="middle" @click="$goBack">
        <wd-icon name="arrow-left" />
      </div>
      <div>
        <span>实时控制</span>
      </div>
    </wd-navbar>
    <div class="control-content">
      <div class="control-info">
        <span class="stats">
          开关状态：
          <span v-if="equipInfo.equipmentStatus == '开'" style="color: #34d19d">
            {{ equipInfo.equipmentStatus || "- -" }}
          </span>
          <span
            v-else-if="equipInfo.equipmentStatus == '关'"
            style="color: #fa4350"
          >
            {{ equipInfo.equipmentStatus || "- -" }}
          </span>
          <span v-else>{{ equipInfo.equipmentStatus || "- -" }}</span>
        </span>
        <div class="top">
          <img
            v-if="equipInfo.equipmentType == '0'"
            src="~@/assets/img/usage-electr.png"
          />
          <img
            v-else-if="equipInfo.equipmentType == '1'"
            src="~@/assets/img/usage-water.png"
          />
        </div>
        <div class="info-box">
          <h3 class="info-box_title">设备信息</h3>
          <ul class="info-box_content">
            <li>仪表名称：{{ equipInfo.equipmentName || "--" }}</li>
            <li>表计编码：{{ equipInfo.addr || "--" }}</li>
            <li>安装位置：{{ equipInfo.installationSite || "--" }}</li>
            <li>账户编码：{{ equipInfo.acctId || "--" }}</li>
          </ul>
        </div>
      </div>

      <div class="control-record">
        <wd-divider class="control-record_title">设备计量</wd-divider>
        <div class="control-record_listgroup">
          <div class="listgroup-item">
            <img src="~@/assets/img/icon-edit.png" />
            <span>
              <font>抄表示数：</font>
              <font>{{ equipInfo.equipmentCurrentLarge || "--" }}</font>
            </span>
          </div>
          <div class="listgroup-item">
            <img src="~@/assets/img/icon-docMoney.png" />
            <span>
              <font>剩余金额：</font>
              <font>{{ equipInfo.remainingBalance || "--" }}</font>
            </span>
          </div>
          <div class="listgroup-item">
            <img src="~@/assets/img/icon-docMoneyEnlarge.png" />
            <span>
              <font>结算示数：</font>
              <font>{{ equipInfo.equipmentLatestLarge || "--" }}</font>
            </span>
          </div>
          <div class="listgroup-item">
            <img src="~@/assets/img/icon-timerMenu.png" />
            <span>
              <font>结算时间：</font>
              <font>{{ equipInfo.currentDealDate || "--" }}</font>
            </span>
          </div>
        </div>
        <div class="control-record_btnsgroup">
          <wd-button class="btn" @click="readSpread">抄表</wd-button>
          <wd-button class="btn" @click="getInfo(1)">读取开关状态</wd-button>
          <wd-button class="btn" @click="openAndClose('1')">开</wd-button>
          <wd-button class="btn" @click="openAndClose('0')">关</wd-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      equipInfo: {},
      queryParams: {
        pageNum: 1,
        pageSize: 15,
        id: null,
        roleKey: null,
      },
    };
  },
  created() {
    this.queryParams.roleKey = localStorage.getItem("roleKey");
    this.equipInfo = this.$route.params;
    this.queryParams.id = this.equipInfo.id;
    if (!this.equipInfo.id) {
      this.$router.push("/control");
    } else {
      this.getInfo();
    }
  },
  methods: {
    readSpread() {
      this.$http
        .post("/external/equipment/reading", { id: this.equipInfo.id })
        .then((res) => {
          if (res.code == 200) {
            this.$toast.success("抄表成功！");
            this.getInfo();
          } else {
            this.$toast.error(res.msg);
          }
        });
    },
    getInfo(type = 0) {
      this.$http
        .get("/external/equipment/equipment/list", { params: this.queryParams })
        .then((res) => {
          if (res.code == 200) {
            this.equipInfo = res.rows[0];
            if (type == 1) {
              this.$toast.success("读取成功！");
            }
          }
        });
    },
    openAndClose(cmd) {
      let text = cmd == "0" ? "关闭" : "开启";
      this.$messageBox.confirm("是否" + text + "设备", "提示").then(() => {
        this.$http
          .post("/external/equipment/control", {
            id: this.equipInfo.id,
            controlType: cmd,
            controlComment: "C0001",
            businessId: new Date().getTime(),
          })
          .then((res) => {
            if (res.code == 200) {
              if (cmd == "1") {
                this.$toast.success("开闸成功！");
              } else {
                this.$toast.success("关闸成功！");
              }
            } else {
              this.$toast.error(res.msg);
            }
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.app-container {
  background: linear-gradient(to bottom, #eaf1ff, rgba(233, 242, 255, 0));
  .control-content {
    padding: 10px 15px;
    .control-info {
      .stats {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 10px;
        font-size: 15px;
        color: #666666;
      }
      .top {
        margin: 20px 0 25px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 115px;
          height: 115px;
        }
      }
      .info-box {
        padding: 10px 15px;
        background-color: #fff;
        border-radius: 7px;
        box-shadow: 0 0 10px 0px rgba(172, 190, 229, 0.5);
        .info-box_title {
          margin: 0;
          font-size: 15px;
          text-align: center;
          margin-bottom: 10px;
        }
        .info-box_content {
          padding: 0;
          margin: 0;
          list-style: none;
          li {
            height: 25px;
            line-height: 25px;
          }
        }
      }
    }
    .control-record {
      .control-record_title {
        margin: 15px 0px;
        ::v-deep .wd-divider__content {
          font-size: 15px;
          font-weight: bold;
          color: #000;
        }
        ::v-deep .wd-divider__line {
          height: 1.5px;
          background: rgba(172, 190, 229, 1);
        }
      }
      .control-record_listgroup {
        margin-bottom: 20px;
        .listgroup-item {
          display: flex;
          justify-content: start;
          align-items: center;
          margin-bottom: 10px;
          height: 80px;
          background-color: #fff;
          border-radius: 7px;
          box-shadow: 0 0 10px 0px rgba(172, 190, 229, 0.5);
          img {
            width: 50px;
            height: 50px;
            margin: 0 15px 0 20px;
          }
          span font:first-of-type {
            font-weight: bold;
            line-height: 80px;
            color: #396bdb;
          }
        }
        .listgroup-item:last-of-type {
          margin-bottom: 0;
        }
      }
      .control-record_btnsgroup {
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-wrap: wrap;
        margin-bottom: 10px;
        .btn {
          width: 150px;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
